<app-navbar *ngIf="authService.isLogged() && localStorageService.getData('authorizations')"></app-navbar>
<app-sidenav *ngIf="authService.isLogged() && localStorageService.getData('authorizations')"></app-sidenav>
<main>
  <router-outlet></router-outlet>
</main>
<app-overlay
  icono="bi bi-info-circle-fill"
  mensaje="Sin autorización para esta acción."
  *ngIf="isAuthorized"
></app-overlay>
